import React from "react";
import { Box } from "@mantine/core";
import { FullScreenLayoutProps } from "./FullScreenLayout.types";

export const FullScreenLayout: React.FC<FullScreenLayoutProps> = ({
  children,
  direction = "column",
  justify = "flex-start",
  align = "stretch",
  gap = 0,
  wrap = "nowrap",
}) => {
  return (
    <Box
      className="full-screen-layout"
      style={(theme) => ({
        width: "100vw",
        height: "100vh",
        backgroundColor: theme.colors.white,
        overflow: "hidden",
        display: "flex",
        flexDirection: direction,
        justifyContent: justify,
        alignItems: align,
        gap: typeof gap === "number" ? `${gap}px` : gap,
        flexWrap: wrap,
      })}
    >
      {children}
    </Box>
  );
};
